export const getUserFirstName = (fullname) => {
  return fullname.split(' ')[0];
};
